import { Injectable, Output, EventEmitter } from '@angular/core'

@Injectable()
export class BorradorStorageService {

  changed = false;

  @Output() change: EventEmitter<boolean> = new EventEmitter();

  cambioStorage() {
    this.changed = !this.changed;
    this.change.emit(this.changed);
    console.log('cambio en storage')
  }

}